import { db } from './db.ts';

/** Shared helpers for module search providers (simple, reliable, on-device). */

export function normalize(text: string): string {
  return text.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '');
}

/** Score a record's text fields against a query: every term must match somewhere. */
export function scoreText(query: string, fields: (string | null | undefined)[], titleIndex = 0): number {
  const terms = normalize(query).split(/\s+/).filter(Boolean);
  if (terms.length === 0) return 0;
  const hay = fields.map((f) => normalize(f ?? ''));
  let score = 0;
  for (const term of terms) {
    let best = 0;
    hay.forEach((h, i) => {
      if (!h.includes(term)) return;
      const weight = i === titleIndex ? 3 : 1;
      best = Math.max(best, (h.startsWith(term) || h.includes(` ${term}`) ? 2 : 1) * weight);
    });
    if (best === 0) return 0;
    score += best;
  }
  return score;
}

export async function familyRecords<T = Record<string, unknown>>(collection: string, familyId: string): Promise<(T & { id: string })[]> {
  return (await db.records(collection).where('familyId').equals(familyId).toArray()) as unknown as (T & { id: string })[];
}
